/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconCopy({ className }) {
  return (
    <svg className={className} fill="none" height="21" viewBox="0 0 17 21" width="17" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.0028 3.12704L2 5.25V15.7542C2 17.5491 3.45507 19.0042 5.25 19.0042L13.8663 19.0045C13.5573 19.8782 12.724 20.5042 11.7444 20.5042H5.25C2.62665 20.5042 0.5 18.3776 0.5 15.7542V5.25C0.5 4.26929 1.12745 3.43512 2.0028 3.12704ZM14.25 0.5C15.4926 0.5 16.5 1.50736 16.5 2.75V15.75C16.5 16.9926 15.4926 18 14.25 18H5.25C4.00736 18 3 16.9926 3 15.75V2.75C3 1.50736 4.00736 0.5 5.25 0.5H14.25Z" fill="#5E811E"/>
    </svg>
  );
}
IconCopy.propTypes = {
  className: PropTypes.string
};
